import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCategory extends Layout {
    checkboxCarrier: Checkbox;
    checkboxCustomer: Checkbox;
    checkboxLocation: Checkbox;
    checkboxVehMnt: Checkbox;
    checkboxVendor: Checkbox;
    labelAppliesTo: Label;
    panelCheckBoxes: Panel;
    sourceCategory: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
